module.exports = __webpack_public_path__ + "static/media/hospital.af255806.png";